import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { IAppState } from '../app.state';
import { copyShare, moveNote } from '../share/share.actions';
import { selectCurrentProfile } from '../profile/profile.selector';
import { ProfileService } from '../profile/profile.service';

@Injectable()
export class ShareCopyService {
  isLoggedIn;
  constructor(
    public _store: Store<IAppState>,
    public _profile: ProfileService,
  ) {
    const profile$ = this._store.pipe(select(selectCurrentProfile));
    profile$.subscribe((profile) => {
      this.isLoggedIn = !!profile;
    });
  }

  copy() {
    if (this.isLoggedIn) {
      this._store.dispatch(copyShare());
    } else {
      this._profile.goToAuth()
    }
  }

  move(noteId, currentWorkspaceId, workspaceIdToMove) {
    this._store.dispatch(moveNote(noteId, currentWorkspaceId, workspaceIdToMove));
  }
}
